import React from "react";
import PropTypes from "prop-types";
import {useRouteError, Link} from "react-router-dom";

const ComponentError = ({ children }) => {
    const error = useRouteError();

    // You can check for specific error types and customize the display accordingly
    const getErrorMessage = () => {
        if (error.status === 404) {
            return {
                title: 'Page Not Found',
                description: 'Sorry, the page you are looking for does not exist.'
            };
        }

        if (error.status === 401) {
            return {
                title: 'Unauthorized',
                description: 'You need to be logged in to access this page.'
            };
        }

        // Default error message
        return {
            title: 'Unexpected Error',
            description: error.message || 'Something went wrong. Please try again later.'
        };
    };

    const errorDetails = getErrorMessage();
    console.error("COMPONENT ERROR",errorDetails)

    return (
        <div className="flex items-center justify-center w-full">
            <div className="page-error" style={TB.createStyledCircle(TB.config("color.danger"), 0.1)}>

                <div className="white-panel">
                    <i className="fas fa-exclamation-circle text-danger fa-5x" />
                    <h3>Something went wrong</h3>

                    <p>It appears there was something on this page caused an issue and we are looking into it. Please try again later.</p>

                    {children}


                    {/* Add a home button */}
                    <div className="mt-4">
                        <Link
                            to={TB.auth().appropriate()}
                            className="bg-red-100 text-red-900 px-4 py-2 rounded hover:bg-red-200 transition-colors"
                        >
                            Return Home
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

ComponentError.propTypes = {
    children: PropTypes.any,
};

export default ComponentError;